import { ConfiguracaoTermoRequestDTO } from "../dtos/ConfiguracaoTermoRequestDTO";
import { ConfiguracaoTermoResponseDTO } from "../dtos/ConfiguracaoTermoResponseDTO";

export class ConfiguracaoTermoService {
  private baseUrl = `${import.meta.env.VITE_API_URL}/configuracao-termo`;

  async getConfiguracao(token: string): Promise<ConfiguracaoTermoResponseDTO | null> {
    const response = await fetch(this.baseUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (response.status === 404) {
      // Configuração não existe ainda
      return null;
    }

    if (!response.ok) {
      const erro = await response.json();
      throw new Error(erro.message || "Erro ao buscar configuração.");
    }

    const data = await response.json();
    return data.data;
  }

  async criar(configuracao: ConfiguracaoTermoRequestDTO, token: string) {
    const response = await fetch(this.baseUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(configuracao),
    });

    if (!response.ok) {
      const erro = await response.json();
      throw new Error(erro.message || "Erro ao criar configuração.");
    }

    const data = await response.json();
    return data.data;
  }

  async atualizar(id: number, configuracao: Partial<ConfiguracaoTermoRequestDTO>, token: string) {
    const response = await fetch(`${this.baseUrl}/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(configuracao),
    });

    if (!response.ok) {
      const erro = await response.json();
      throw new Error(erro.message || "Erro ao atualizar configuração.");
    }

    const data = await response.json();
    return data.data;
  }
}

